module.exports = __webpack_public_path__ + "static/media/carousel6.e5946080.jpeg";